import React, { Component } from 'react'
import { Alert, Platform } from 'react-native'
import AsyncStorage from '@react-native-async-storage/async-storage';
import * as SQLite from 'expo-sqlite';








//SQLite.enablePromise(true);

function errorCB (err) {
  console.log("SQL Error: " + err);
}
 
function successCB  (){
  console.log("SQL executed fine");
}
 
function openCB  () {
  console.log("Database OPENED");
}
export const openDatabase = () => {
  if (Platform.OS === "web") {
    return {
      transaction: () => {
        return {
          executeSql: () => {},
        };
      },
    };
  }

  const db = SQLite.openDatabase("Users.db");
  return db;
}


const db = openDatabase()
//export const db;

export const createUserTable = async () => {

  db.transaction((tx) => {
    tx.executeSql(
      "create table if not exists users (id integer primary key not null, email text, name text, role text, onboarded text);"
    );
  });

  // create table if not exists
  
  };



  export const createRecentTable = async () => {

    db.transaction((tx) => {
      tx.executeSql(
        "create table if not exists recents (id integer primary key not null, title text, image text, video_url text);"
      );
    });
  
    // create table if not exists
    
    };
  
  export const saveAuth = async (email, role, fullname) => {
    db.transaction(
      (tx) => {
        tx.executeSql("insert into users (email, role, name, onboarded) values (?, ?, ?, 'yes')", [email, role, fullname]);
        tx.executeSql("select * from users", [], (_, { rows }) =>
          console.log(JSON.stringify(rows))
        );
      },
      null
    );
  };
  
  
  export const SaveRecents = async (id, title, image, video_url) => {
    db.transaction(
      (tx) => {
        tx.executeSql("insert into recents (key, title, image, video_url) values (?, ?, ?, ?)", [id, title, image, video_url]);
        tx.executeSql("select * from recents where id = ? order by id desc limit 1", [id], (_, { rows }) =>
          console.log(JSON.stringify(rows))
        );
      },
      null
    );
  };
  
  export const getRecents = async () => {
    db.transaction(
      (tx) => {
         tx.executeSql("select * from recents where 1 order by id desc limit 5", [], (_, { rows }) => {
          //console.log(rows.length)
          return rows.length
      });
      },
      null
    );
  };
  

  export const deleteAuth = async (id) => {
    const deleteQuery = `DELETE from ${tableName} WHERE 1`;
    await db.executeSql(deleteQuery);
  };

export const getAuth = () => {
  db.transaction(
    (tx) => {
      
      tx.executeSql("select * from users", [], (tx, rows) => { 
  return rows.rows._array[0]
     // return JSON.stringify(rows._array[0])

     
    });
    },
    errorCB
  );

}





export const StoreLoginState = async (value) => {
  try {
    await AsyncStorage.setItem('id', value)
  } catch (e) {
    console.log('Unable to Save Email, ' + e);
  }
}

export const SaveRecent = async (values) => {
    try {
      await AsyncStorage.setItem('id', value)
    } catch (e) {
      console.log('Unable to Save Email, ' + e);
    }
  }

 export const StoreLoginRole = async (value) => {
  try {
    await AsyncStorage.setItem('role', value)
   } catch (e) {
     console.log('Unable to Save role, ' + e);
   }
}

 export async function StoreAccessCode (value) {
  try {
    await AsyncStorage.setItem('AccessCode', value)
  } catch (e) {
    console.log('Unable to Save Telephone Number');
  }
}

export async function StorePageCategory (value) {
  try {
    await AsyncStorage.setItem('category', value)
  } catch (e) {
    console.log('Unable to Save Page Category');
  }
}
 export async function StoreTelephoneNumber (value) {
  try {
    await AsyncStorage.setItem('TelephoneNumber', value)
  } catch (e) {
    console.log('Unable to Save Telephone Number');
  }
}


 export async function StoreVerMessage (value) {
  try {
    await AsyncStorage.setItem('VerMessage', value)
  } catch (e) {
    console.log('Unable to Save VerMessage');
  }
}

export async function clearAll(){
  try {
    await AsyncStorage.clear()
  } catch(e) {
    // clear error
    console.log(e)
  }

  console.log('Done.')
}

export async function getAll(){
  try {
    const value = await AsyncStorage.getAllKeys()
    return value.map(req => req).forEach(console.log);
  } catch(e) {
    // clear error
    console.log(e)
  }
  
  console.log('Done.')
}

 export async function getLoginState () {
  try {
    const value = await AsyncStorage.getItem('id')
    if(value !== null) {
      // value previously stored
      //console.log(value);
      return value;

    }
  } catch(e) {
    console.log(e);
    
  }
}

export function getPageCategory () {
  try {
    const value = AsyncStorage.getItem('category');
    //return value;
    if(value !== null) {
      // value previously stored
      //console.log(value);
      return value;

    }
  } catch(e) {
    console.log(e);
    
  }
}
 export async function getTelephoneNumber () {
  try {
    const value = await AsyncStorage.getItem('TelephoneNumber')
    if(value !== null) {
      // value previously stored
      //console.log(value);
      return value;

    }
  } catch(e) {
    console.log(e);
    
  }
}
 export async function getVerMessage () {
  try {
    const value = await AsyncStorage.getItem('VerMessage')
    if(value !== null) {
      // value previously stored
      //console.log(value);
      return value;

    }
  } catch(e) {
    console.log(e);
    
  }
}


 export async function getLoginRole () {
  try {
    const value = await AsyncStorage.getItem('role')
    if(value !== null) {
      // value previously stored
      //console.log(value);
      
      return value;
   
    }
  } catch(e) {
    console.log(e);
    
  }
}


